import axios from 'axios';

import type {
  IUserGetUserAuthActionsQuery,
  IUserGetUserAuthActionsRequest,
  IUserGetUserAuthActionsResponse,
} from '@/app-package';

const getUserAuthActions = async ({
  page = 1,
  userId,
  itemsPerPage,
}: IUserGetUserAuthActionsQuery) => {
  const config: IUserGetUserAuthActionsRequest = {
    url: '/user/actions/auth',
    method: 'get',
    params: { page, userId, itemsPerPage },
  };

  const { data } = await axios.request<IUserGetUserAuthActionsResponse>(config);

  return data;
};

export default getUserAuthActions;
